import React from 'react';
import './css/Screens.scss';

class Screen extends React.Component {

    constructor(props) {
        super(props);
        this.state = { state: "OFF", graphState: "BGStar", window: null, VTCConnected: false }; //SET OFF FOR REAL DEMO
    }

    boot = () => this.setState( { state: "BOOT" } );

    setGraph = state => this.setState( { graphState: state } );

    onClick = ev => {

        ev.target.id && ev.button === 0 && document.dispatchEvent( new CustomEvent( "targetClicked", { detail: ev.target } ) );

    }

    showWindow = window => this.setState( { window: window === this.state.window ? null : window } );

    componentDidMount() {

        document.addEventListener( "Reset", ev => {

            this.initScreenProps = null;
            this.setState( { state: "OFF", graphState: "BGStar", window: null, VTCConnected: false } );

        })

        document.addEventListener( "init", ev => {

            if( ev.detail.includes( "Screen" ) ) {

                this.initScreenProps = { keys: ["Experiment", "Recycle Delay", "Maximum T1"], values: ["NP/S", "0.19", "0.03678"] };
                this.setState( { state: "SOFTWARE", VTCConnected: true } );

            }

        })

        document.addEventListener( "setWindow", ev => this.showWindow( ev.detail ) )

    }

    render() {

        const getScreen = () => {

            switch( this.state.state ){

                case "OFF":
                    return null
                case "BOOT":
                    setTimeout( () => this.setState( { state: "DESKTOP" } ), 3000 );
                    return (
                        <React.Fragment>
                            <h1>Booting...</h1>
                        </React.Fragment>
                    )
                case "DESKTOP":
                    return (
                        <React.Fragment>
                            <h1>Desktop</h1>
                            <button onClick={() => this.setState( { state: "SOFTWARE" } )} id="SoftwareStart">
                                <img alt="" src="./img/Stelar.bmp" style={{width:"200px", imageRendering:"pixelated", pointerEvents:"none"}}/><br/>
                                AcqNmrV95
                            </button>
                        </React.Fragment>
                    )
                case "SOFTWARE":
                    return (
                        <React.Fragment>
                            <div className="stelarScreen">
                                <div className="screenSection windowFooter">
                                    <div />
                                    <div />
                                </div>
                                <div className="screenSection" style={{height:"695px"}}>
                                    <DisplaySettings initProps={this.initScreenProps}/>
                                    <div className="component-graphScreen">
                                        <img alt="" src={`./img/${this.state.graphState}.png`} style={this.state.graphState === "BGStar" ? {position: "absolute"} : {width:"100%", height:"100%"}}/>
                                    </div>
                                </div>
                                <div className="screenSection" style={{backgroundColor:"#F0F0F0"}}>
                                    <DisplayButtons showWindow={this.showWindow}/>
                                    <HeaterControlPanel connected={this.state.VTCConnected}/>
                                </div>
                                <div className="screenSection">
                                    <DisplayHeader showWindow={this.showWindow}/>
                                </div>
                                {this.state.window === "Eval" ? <EvaluationDialog showWindow={this.showWindow}/> : null}
                                <ProfileWizard window={this.state.window} showWindow={this.showWindow}/>
                            </div>
                        </React.Fragment>
                    )
                default:
                    return null;
            }

        }

        return (

            <div className="component-screen" onMouseDown={this.onClick}>
                {getScreen()}
            </div>

        )
    }
}

class HeaterControlPanel extends React.Component {

    constructor(props) {
        super(props);
        this.state = { activeMenu: null };
    }
    menu = ev => {

        ev.preventDefault();

        document.dispatchEvent( new CustomEvent( "targetClicked", { detail: ev.target } ) );
        this.setState( { activeMenu: "main" } );

    }
    render() {
        return (
            <div id="heater_controls" className="component-heatercontrolpanel" onContextMenu={this.menu} onMouseLeave={() => this.setState( { activeMenu: null } )}>
                <p>VTC:</p>
                <p>{this.props.connected ? "Connected" : "Not connected"}</p>
                {this.state.activeMenu ? <DisplayMenu menu={{"Connect": true, "Set Point": this.props.connected, "Reset": false, "Disconnect": false, "Precision": false}} parent={this}/> : null}
            </div>

        )

    }

}

const DisplayButtons = props => (
            <div className="component-displaybuttons">
            {[["Gun", "Start acquisition"], ["Save", "Save data"], ["Zap", "Zap last zone"], ["CorrectF1", "Correct F1"], ["CorrectT1MX", "Correct T1MX"], ["Eval", "Evaluation dialog"], ["RepeatEval", "Repeat evaluation"], ["Flag", "Go & Adjust"], ["Testtube", "Update hardware"]].map( button => <img key={button[0]} id={button[0]} src={`./img/${button[0]}.png`} onClick={button[0] === "Eval" ? () => props.showWindow( "Eval" ) : null} title={button[1]} alt={button[1]}></img>)}
            </div>
);

class DisplaySettings extends React.Component {

    constructor(props) {
        super(props);
        this.state = { activeTab: "Main par", activeSubTab: "" };
        this.tabs = {
            "default": "Main par",
            "Main par": [
                ["SMPL", "Sample", "Water", true],
                ["EXP", "Experiment", "S1P", ["ANGLE.FFC","PP","PP/S","NP","NP/S","PP1E","PP1E/S","NP1E","NP1E/S","..."]],
                ["TEMP", "Temperature", "25"],
                ["FILE", "Data Acquisition File", ""],
                ["F1", "Observe Offset", "0"],
                ["RFA", "Rf attenuation", "0"],
                ["", "", ""],
                ["RD", "Recycle Delay", "0.1", true],
                ["EDLY","",""],
                ["TAU","Delay Tau","0.1", true],
                ["T1MX","Maximum T1","", true],
                ["AUXC","",""],
                ["SWT","Switching time","0.003"],
                ["TPOL","",""],
                ["BPOL", "Polarization field", "7.99"],
                ["BRLX", "Relaxation field", "0.099", true],
                ["BACQ", "Acquisition field", "8.99"]
            ],
            "Acq. par": {
                "default": "Basic",
                "User": false,
                "Basic": [
                    ["NUC", "Nucleus", "1H"],
                    ["EXP", "Experiment", "S1P", ["ANGLE.FFC","PP","PP/S","NP","NP/S","PP1E","PP1E/S","NP1E","NP1E/S","..."]],
                    ["SF", "System frequency", "9"],
                    ["F1", "Observe offset", "0"],
                    ["MS", "Maximum scans", "1"],
                    ["DS", "Dummy scans", "0"],
                    ["NS", "Completed Scans", "0"],
                    ["BS", "Block size", "1024"],
                    ["STIM", "Sweep time", "0.0001024"],
                    ["SW", "Sweep width", "10000000"],
                    ["FLTR", "Observe filter", "60000"],
                    ["RTIM", "Repetition time", "0.10014106"],
                    ["TTIM", "Total time", "0.10014106"],
                    ["RFA", "Rf attenuation", "0"]
                ],
                "Puls": false,
                "Delay": false,
                "nDim": false,
                "Conf": [
                    ["HEAD", "Probehead", "Standard 10 mm"],
                    ["PW90", "90deg pulse [us]", "4.6", true],
                    ["B1", "B1 field", "12.76519697"],
                    ["PDMX", "Phase/Diode", "P"],
                    ["FTM", "FT mode", "0"],
                    ["RPHS", "Receiver phase", "19.37785357"],
                    ["QPHC", "QD phase setting", "90"],
                    ["PHCY", "Phase cycle enable", "Y"],
                    ["RINH", "Receiver inhibit [us]", "10"],
                    ["ACQD", "Acquisition delay [us]", "20"],
                    ["AFLT", "Autofilter mode", "N"],
                    ["PWT2", "90deg Tx2  pulse [us]", "10"],
                    ["B2", "B2 field", "5.871990605"],
                    ["PWT3", "90deg Tx3  pulse [us]", "40"],
                    ["B3", "B3 field", "1.467997651"],
                    ["SWT", "Switching time", "0.003"],
                    ["VTCT", "VTC interface type", "VTC91"],
                    ["VTCD", "VTC delay [min]", "5"],
                    ["SWTM", "Switching time mode", "FIXED"],
                    ["SWTE", "Acq extra settling", "0"],
                    ["DAAM", "Acq/Acc mode", "BASIC"],
                    ["DAAP", "Acq/Acc parameter", "0.2"],
                    ["WTRG", "Waiting for Trigger", "NONE"],
                ],
                "Hard": false

            },
            "Evaluation": {
                "default": "Quick results",
                "Quick results": [
                    ["", "T1:", ""],
                    ["EDF1", "Data file", ""],
                    ["EDZ1", "Data zone", ""],
                    ["EACV", "Relaxation   field", ""],
                    ["ET1", "T1 [s]", ""],
                    ["ER1", "R=1/T1 [1/sec]", ""],
                    ["ER1D", "R Error [+/-]", ""],
                    ["ER1E", "R Error [%]", ""],
                ],
                "Parameters": false
            },
            "Report": false,
            "Log": false
        }

        this.displaySettingsListener( { detail: this.props.initProps } );
    }

    setTabValue = ( value, state, lookup ) => {

        lookup = lookup || this.tabs;

        Object.keys( lookup ).forEach( tab => {

            if( typeof lookup[ tab ] === "object" && lookup[ tab ].constructor === Object ){

                this.setTabValue( value, state, lookup[ tab ] );

            } else if( lookup[ tab ] instanceof Array ){

                if( lookup[ tab ].some( val => val[1] === value ) ){

                    lookup[ tab ].find( val => val[1] === value )[2] = state;
                    if( document.getElementById( value ) ) document.getElementById( value ).innerHTML = state;

                }

            }

        })
    }

    turnToInput = ev => {

        ev.stopPropagation();

        const node = ev.target.cloneNode();

        const input = document.createElement( "input" );
        input.setAttribute( "value", ev.target.innerHTML );
        input.setAttribute( "id", node.id );
        input.setAttribute( "size", "7" );
        input.addEventListener( "keydown", ev => {
            ev.key === "Enter" && this.turnBackFromInput( input, node );
        } );
        input.addEventListener( "focusout", () => this.turnBackFromInput( input, node ) )

        ev.target.replaceWith( input );
        input.focus();
        input.select();

    }

    turnBackFromInput = ( input, original ) => {

        this.sendEvent( input );

        original.innerHTML = input.value;
        original.addEventListener( "click", this.turnToInput );


        try{

            input.replaceWith( original );
            this.setTabValue( input.id, input.value );

        } catch(err){}

    }

    setDropdown = ev => {

        this.sendEvent( ev.target );

        this.tabs["Main par"][1][2] = ev.target.value;
        this.tabs["Acq. par"]["Basic"][1][2] = ev.target.value;

        this.setTabValue( "Recycle Delay", "0.1" );
        this.setTabValue( "Relaxation field", "3.9999" );

    }

    sendEvent = detail => document.dispatchEvent( new CustomEvent( "targetClicked", { detail: detail } ) );

    displaySettingsListener = ev => {

        ev.detail && ev.detail.keys.forEach( ( key, i ) => this.setTabValue( key, ev.detail.values[i] ) );

    }

    componentDidMount() {

        document.addEventListener( "updateDisplaySettings", this.displaySettingsListener );

    }

    componentWillUnmount() {

        document.removeEventListener( "updateDisplaySettings", this.displaySettingsListener );

    }

    drawTab = ( tabs, sub ) => {

        const activeTab = sub ? this.state.activeSubTab : this.state.activeTab;

        return (
            <React.Fragment>
                <div className="DisplayTabHeader">
                    {Object.keys( tabs ).filter( tab => tab !== "default" ).map( tab => {
                        return (
                            <div key={tab} id={tab} className={"DisplayTabSelector " + ( tab === activeTab ? "active" : "" ) } onClick={() => tabs[tab] ? this.setState( sub ? { activeSubTab: tab } : { activeTab: tab, activeSubTab: tabs[tab].default } ) : null}>
                                <p>{tab}</p>
                            </div>
                        )
                    })}
                </div>
                { tabs[ activeTab ] instanceof Array ?
                    (
                        <div className="DisplayActiveTab">
                            <table>
                                <colgroup>
                                    <col width="15%"/>
                                    <col width="55%"/>
                                    <col width="30%"/>
                                </colgroup>
                                <tbody>
                                {tabs[activeTab].map( ( val, i ) => {
                                    return (
                                        <tr key={i}>
                                            <td>{val[0]}</td>
                                            <td>{val[1]}</td>
                                            {val[3] instanceof Array ?
                                                <td className="customSelect">
                                                    <label>
                                                        <select id={val[1]} onChange={this.setDropdown} defaultValue={val[2]}>
                                                            {val[3].map( opt => <option key={opt} value={opt}>{opt}</option> )}
                                                        </select>
                                                    </label>
                                                </td> :
                                                <td id={val[1]} suppressContentEditableWarning onClick={val[3] ? this.turnToInput : null}>{val[2]}</td>}
                                        </tr>
                                    )
                                })}
                                </tbody>
                            </table>
                        </div>
                    ):
                    this.drawTab( tabs[ activeTab ], true ) }
            </React.Fragment>
        )

    }

    render() {
        return (
            <div className="component-displaysettings">
                {this.drawTab( this.tabs, false )}
            </div>
        )
    }
}

class DisplayHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = { activeMenu: null };
        this.menus = {

            "Actions": {

                "Immediate Mode": false,
                "Go & Adjust": false,
                "Zap last data zone": false,
                "Kill current action": false,
                "hr": "---",
                "Load parameters": false,
                "Save parameters": false,
                "hr1": "---",
                "Profile Wizard": () => this.props.showWindow( "Profile" ),
                "Execute Macro": false

            },
            "Evaluate": false,
            "Utilities": false,
            "Hardware": {

                "Update": false,
                "Boot": false,
                "Tune probe": false,
                "Magnet": {
                    "Switch Off": false,
                    "Switch On": true,
                    "hr": "---",
                    "Calibrate offset": false
                },
                "hr": "---",
                "Diagnostics": false,
                "DigiScope": false

            },
            "View": false,
            "Help": false,
            "Exit": false

        };
    }
    render() {
        return (
            <div className="component-displayheader" onMouseLeave={() => this.setState( {activeMenu: null} )}>

                {Object.keys( this.menus ).map( menu =>
                    ( <div key={menu} id={menu} className={this.state.activeMenu === menu && this.menus[menu] ? "clicked" : ""} onClick={() => this.setState( { activeMenu: menu })}>

                        {menu}
                        {this.state.activeMenu === menu && this.menus[menu] ? <DisplayMenu menu={this.menus[menu]} parent={this}/> : null}

                    </div> ) )}

            </div>
        )
    }
}

class DisplayMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = { activeMenu: null };
    }

    componentWillUnmount() {
        clearTimeout( this.timeout );
    }

    render() {

        const isObj = ( obj ) => obj.constructor === Object;

        return (
            <div className="component-displaymenu" style={{top:this.props.X, left: this.props.Y}}>
                {Object.keys( this.props.menu ).map( menu =>
                    this.props.menu[menu] === "---" ?
                    (<hr key={menu}/>):
                    (<div
                        key={menu}
                        id={menu}
                        className={( isObj(this.props.menu[menu] ) ? "subMenu" : "" ) + ( this.props.menu[menu] ? "" : "menuGreyedOut" ) }
                        onMouseEnter={ev => {
                            const tar = ev.target;
                            clearTimeout( this.timeout );
                            this.timeout = setTimeout( () => {
                                this.setState( { activeMenu: menu } );
                                isObj( this.props.menu[menu] ) && document.dispatchEvent( new CustomEvent( "targetClicked", { detail: tar } ) )
                            }, 200 )
                        }}
                        onMouseUp={ev => {
                            if( !(isObj( this.props.menu[menu] )) && this.props.menu[menu] ){
                                this.props.parent.setState( { activeMenu: null } );
                            }
                        }}
                        onMouseDown={this.props.menu[menu] instanceof Function ? this.props.menu[menu] : null}
                    >
                        {menu}
                        {this.state.activeMenu === menu && isObj( this.props.menu[menu] ) ? <DisplayMenu menu={this.props.menu[menu]} parent={this.props.parent}/> : null}
                    </div>)
                )}
            </div>
        )
    }

}

class HeaterScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {displayText:""};
    }
    onClick = ev => {

        ev.target.id && document.dispatchEvent( new CustomEvent( "targetClicked", { detail: ev.target } ) );

    }

    addToDisplay = ev => {
        this.state.displayText.length < 4 && this.setState( { displayText: this.state.displayText + ev.nativeEvent.target.id.split( "_" )[1] } );
    }

    setDisplay = val => {
        this.setState( {displayText: val} );
    }

    resetDisplay = ev => {
        this.setDisplay( "" );
    }

    render() {
        return (
            <div className="component-heaterscreen" onClick={this.onClick}>
                <div className="heater-display">
                {this.state.displayText}
                </div>
                <div className="keypad">
                    <table>
                        <tbody>
                            <tr>
                                <td className="keypad_red" id="keypad_reset" onClick={this.resetDisplay}><div>Reset</div></td>
                                <td id="keypad_7" onClick={this.addToDisplay}><div>7</div></td>
                                <td id="keypad_8" onClick={this.addToDisplay}><div>8</div></td>
                                <td id="keypad_9" onClick={this.addToDisplay}><div>9</div></td>
                            </tr>
                            <tr>
                                <td className="keypad_red" id="keypad_calc"><div>Calc</div></td>
                                <td id="keypad_4" onClick={this.addToDisplay}><div>4</div></td>
                                <td id="keypad_5" onClick={this.addToDisplay}><div>5</div></td>
                                <td id="keypad_6" onClick={this.addToDisplay}><div>6</div></td>
                            </tr>
                            <tr>
                                <td className="keypad_red" id="keypad_frm"><div>Frm</div></td>
                                <td id="keypad_1" onClick={this.addToDisplay}><div>1</div></td>
                                <td id="keypad_2" onClick={this.addToDisplay}><div>2</div></td>
                                <td id="keypad_3" onClick={this.addToDisplay}><div>3</div></td>
                            </tr>
                            <tr>
                                <td className="keypad_red" id="keypad_adv"><div>Adv</div></td>
                                <td className="keypad_red" id="keypad_+-"><div>+/-</div></td>
                                <td id="keypad_0" onClick={this.addToDisplay}><div>0</div></td>
                                <td className="keypad_red" id="keypad_enter" onClick={this.resetDisplay}><div>Enter</div></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

}

const EvaluationDialog = props => (
            <div className="component-evaluationdialog vertical">
                <div>
                    <div>
                        <h1>Data source</h1>
                        <div className="vertical" style={ { marginTop: "-15px", width: "60%", alignSelf: "flex-end" } }>
                            <label><input type="radio" checked disabled/>User file</label>
                            <label><input type="radio" disabled/>Data Acquisition File</label>
                        </div>
                        <div className="vertical" style={{ height: "80%" } }>
                            <h1>File</h1>
                            <input type="text" disabled/>
                            <button className="noStyle">Change file</button>
                            <div style = {{ height: "100%", fontFamily: "monospace", backgroundColor: "#FFFFE1", fontSize: "22px" } }>
                                Info about your data file...
                            </div>
                        </div>
                    </div>
                    <div>
                        <h1>Evaluation procedure:</h1>
                        <select id="EvaluationProcedure" onChange={ev=> document.dispatchEvent( new CustomEvent( "targetClicked", { detail: ev.target } ) )}>
                            {["LSP List stored parameters", "WAV Window: Averages", "WSM Window: Signed magnitudes", "WAM Window: Absolute magnitude", "RAM Relax.rate using WAM", "RSM Relax.rate using WSM", "RAV Relax.rate using real WAV", "T2M T2* using magnitudes", "T2R T2* using real parts", "OFP Offset & phase estimate", "LRD List raw data"].map( val => <option key={val}>{val}</option>)}
                        </select>
                        <div className="vertical">
                            <h1>Results Destination</h1>
                            <div className="noStyle" style={ { marginTop: "-25px", display: "flex", justifyContent: "space-evenly" } }>
                                <label><input type="checkbox" checked disabled/>Report sheet</label>
                                <label><input type="checkbox" checked disabled/>Graphs</label>
                                <label><input type="checkbox" disabled/>Export File</label>
                            </div>
                        </div>
                        <div className="vertical">
                            <h1>Export File</h1>
                            <input type="text" disabled/>
                            <div className="noStyle" style={{ display: "flex", justifyContent: "space-evenly" }}>
                                <button className="noStyle">Change file</button>
                                <label><input type="radio" checked disabled/>Overwrite</label>
                                <label><input type="radio" disabled/>Append</label>
                            </div>
                        </div>
                        <div>
                            <button id="EvalCancel" onClick={ () => props.showWindow() } className="noStyle">Cancel</button>
                            <button id="EvalExecute" onClick={ () => props.showWindow() } className="noStyle">Execute</button>
                        </div>
                    </div>
                </div>
            </div>
);

class ProfileWizard extends React.Component {

    getWindow() {

        switch( this.props.window ){

            case "Profile":
                return (
                    <div className="component-profilewizard">
                        <div className="noStyle" style={{ display: "flex", justifyContent: "space-evenly" }}>
                            <div>
                                <div className="vertical">
                                    <h1>Sequences to use</h1>
                                    <label>At high field:<select disabled><option>NP/S</option></select><button className="noStyle" disabled>Change</button></label>
                                    <label>At low field:<select disabled><option>PP/S</option></select><button className="noStyle" disabled>Change</button></label>
                                    <label>Crossover at:MHz:<input type="text" defaultValue="8" disabled size="6"/></label>
                                </div>
                                <div className="vertical">
                                    <h1>Evaluation procedure</h1>
                                    <select disabled style={{width:"97%"}}><option>RAM</option></select>
                                    <div className="noStyle" style={{display:"flex", paddingLeft:"10px", paddingTop:"5px"}}>
                                        <label>IP:<input type="text" size="1" defaultValue="4" disabled/></label>
                                        <label>EP:<input type="text" size="1" defaultValue="0" disabled/></label>
                                        <label>IB:<input type="text" size="1" defaultValue="1" disabled/></label>
                                        <label>EB:<input type="text" size="1" defaultValue="0" disabled/></label>
                                    </div>
                                </div>
                                <div className="vertical">
                                    <h1>Data file</h1>
                                    <label><input type="text" size="28" disabled/><button id="Data File" className="noStyle">Change</button></label>
                                </div>
                                <div className="vertical">
                                    <h1>Export file</h1>
                                    <label><input type="text" size="28" disabled/><button id="Export File" className="noStyle">Change</button></label>
                                </div>
                                <div className="vertical leftalign">
                                    <h1>Options</h1>
                                    <label style={{marginTop:"-20px"}}><input type="checkbox" checked disabled/>Enable preliminary setup</label>
                                    <label><input type="checkbox" checked disabled/>Enable crossover adjustment</label>
                                    <label><input type="checkbox" checked disabled/>Before each point, estimate T1MX</label>
                                    <label><input type="checkbox" checked disabled/>Before each point, estimate F1</label>
                                </div>
                            </div>
                            <div className="vertical">
                                <h1>Principal parameters</h1>
                                <label>MaxBRLX:<input type="text" size="7" id="MaxBRLX" defaultValue="10" disabled/></label>
                                <label>MinBRLX:<input type="text" size="7" id="MinBRLX" defaultValue="0.01" disabled/></label>
                                <label>Profile points:<input type="text" size="7" id="Profile points" defaultValue="20" disabled/></label>
                                <label>Repetitions/point:<input type="text" size="7" id="Repetitions/point" defaultValue="1" disabled/></label>
                                <label style={{color:"blue"}}>Switching time SWT:<input type="text" size="7" id="Switching time SWT" defaultValue="0.003" disabled/></label>
                                <label style={{color:"blue"}}>Polar.Field BPOL:<input type="text" size="7" id="Polar.Field BPOL" defaultValue="7.999" disabled/></label>
                                <label style={{color:"blue"}}>Polar.Time TPOL:<input type="text" size="7" id="Polar.Time TPOL" defaultValue="0.1" disabled/></label>
                                <label style={{color:"blue"}}>Recycle delay RD:<input type="text" size="7" id="Recycle delay RD" defaultValue="1" disabled/></label>
                                <label style={{color:"blue"}}>Initial T1MX:<input type="text" size="7" id="Initial T1MX" defaultValue="0.016" disabled/></label>
                                <label style={{color:"blue"}}>Tau blocks NBLK:<input type="text" size="7" id="Tau blocks NBLK" defaultValue="16" disabled/></label>
                                <label style={{color:"blue"}}>Number of scans MS:<input type="text" size="7" id="Number of scans MS" defaultValue="1" disabled/></label>
                                <label style={{color:"blue"}}>Dummy scans DS:<input type="text" size="7" id="Dummy scans DS" defaultValue="0" disabled/></label>
                                <label style={{color:"blue"}}>Block size BS:<input type="text" size="7" id="Block size BS" defaultValue="1000" disabled/></label>
                                <label style={{color:"blue"}}>Sweep width SW:<input type="text" size="7" id="Sweep width SW" defaultValue="10000000" disabled/></label>
                                <label style={{color:"blue"}}>AF filter FLTR:<input type="text" size="7" id="AF filter FLTR" defaultValue="300000" disabled/></label>
                                <label style={{color:"blue"}}>RF attenuation RFA:<input type="text" size="7" id="RF attenuation RFA" defaultValue="36" disabled/></label>
                                <label style={{color:"blue"}}>Echo dela EDLY:<input type="text" size="7" id="Echo dela EDLY" defaultValue="10" disabled/></label>
                                <label style={{color:"blue"}}>Temperature TEMP:<input type="text" size="7" id="Temperature TEMP" defaultValue="25" disabled/></label>
                            </div>
                        </div>
                        <div className="profilewizardfooter">
                            <button id="SyncParams" onClick={() => ""} className="noStyle">Synchronize with Acq Parameters</button>
                            <button id="WizardClose" onClick={() => this.props.showWindow()} className="noStyle">Close</button>
                            <button id="WizardExecute" className="noStyle">Execute</button>
                        </div>
                    </div>
                )

            case "DataReasonable":
                return(
                    <div className="component-datareasonable vertical">
                        <div>
                            T1MX  used: 0.03678    found: 0.0386<br/>
                            F1    used:  9000    found: 10908<br/>
                            <br/>
                            The discrepency is small.<br/>
                            Recommended action: Go On
                        </div>
                        <div>
                            <button className="noStyle" onClick={() => this.props.showWindow()}>Abort</button>
                            <button className="noStyle" onClick={() => this.props.showWindow()}>Try Again</button>
                            <button className="noStyle" id="DataReasonableGoOn" onClick={() => this.props.showWindow( "NumRuns" )}>Go On</button>
                        </div>
                    </div>
                )

            case "NumRuns":
                return(
                    <div className="component-numruns vertical">
                        <input type="text" defaultValue="1" disabled/>
                        <div>
                            <button className="noStyle" onClick={() => this.props.showWindow()}>Abort</button>
                            <button className="noStyle" onClick={() => this.props.showWindow()} id="NumRunsOK">Ok</button>
                        </div>
                        <div>
                            Ths fitting error of this 1-scan measurment was 0.44%<br/>
                            <br/>
                            In view of this, specify the number of scans to use.<br/>
                            It is recommended to use multiples of 4.
                        </div>
                    </div>
                )

            default:
                return null

        }

    }

    render(){ return this.getWindow() }


}

export { Screen, HeaterScreen };
